<template>
  <v-card class="mt-3">
    <v-card-title>
      <span>{{sectionLabel}}</span>
      <v-spacer />
      <v-btn color="primary" dark small @click.native="saveForm()">Add</v-btn>
    </v-card-title>
    <v-card-text>
      <v-alert type="info" border="left" dense class="mb-3" v-if="sectionInfoBox">
        {{sectionInfoBox}}
      </v-alert>

      <v-row dense class="customCollapseHeader">
        <v-col cols="2">From Date</v-col>
        <v-col cols="2">To Date</v-col>
        <v-col cols="3">Field of Study</v-col>
        <v-col cols="5">Name of Insititution</v-col>
      </v-row>

      <el-collapse v-model="activeNames" accordion>
        <el-collapse-item :name="i+1" v-for="(form,i) in items" :key="i" :id="'row' + form.id">
          <template slot="title">
            <div v-on:click="getProvince(form)" class="customHead">
              <v-row dense>
                <v-col cols="2">
                  <el-tag type="primary" v-if="form.from_date !== null && form.from_date != undefined">{{ form.from_date | day }}</el-tag>
                </v-col>
                <v-col cols="2">
                  <el-tag type="success" v-if="form.to_date !== null && form.to_date != undefined">{{ form.to_date | day }}</el-tag>
                </v-col>
                <v-col cols="3">{{ form.field_of_study }}</v-col>
                <v-col cols="5">{{ form.name_of_school }}</v-col>
              </v-row>
            </div>
          </template>

          <el-form :model="form" ref="form" label-position="top">
            <v-row dense>
              <v-col cols="6" sm="2" md="3">
                <el-form-item label="From" prop="from_date">
                  <el-date-picker :id="'from_date' + form.id" value-format="yyyy-MM-dd" :picker-options="datePickerOptions" v-model="form.from_date" @change="handleAutoSave(i, form)" v-on:click.native="checkDate($event)" style="width: 100%;"></el-date-picker>
                </el-form-item>
              </v-col>
              <v-col cols="6" sm="2" md="3">
                <el-form-item label="To" prop="to_date">
                  <el-date-picker :id="'to_date' + form.id" value-format="yyyy-MM-dd" :picker-options="datePickerOptions" v-model="form.to_date" @change="handleAutoSave(i, form)" v-on:click.native="checkDate($event)" style="width: 100%;"></el-date-picker>
                </el-form-item>
              </v-col>
              <v-col cols="12" sm="8" md="6">
                <el-form-item label="Name of Insititution" prop="name_of_school">
                  <el-input :id="'name_of_school' + form.id" v-model="form.name_of_school" @change="handleAutoSave(i, form)" style="width: 100%;" />
                </el-form-item>
              </v-col>
              <v-col cols="12" sm="6" v-show="sectionSlug === 'outsideCanada'">
                <el-form-item label="County" prop="country_id">
                  <div class="el-select native-select">
                    <div class="el-input">
                      <select :id="'country_id' + form.id" v-model="form.country_id" placeholder="Select" class="el-input__inner" @change="handleAutoSave(i, form)">
                        <option v-for="(item, index) in country" v-bind:key="index" :value="item.id" :label="item.country_name">{{ item.country_name }}</option>
                      </select>
                    </div>
                  </div>
                </el-form-item>
              </v-col>
              <v-col cols="12" sm="6" v-show="sectionSlug === 'withinCanada'">
                <el-form-item label="Province" prop="province_id">
                  <div class="el-select native-select">
                    <div class="el-input">
                      <select :id="'province_id' + form.id" v-model="form.province_id" placeholder="Select" class="el-input__inner" @change="handleAutoSave(i, form)">
                        <option v-for="(item, index) in province" v-bind:key="index" :value="item.id" :label="item.province_name">{{ item.province_name }}</option>
                      </select>
                    </div>
                  </div>
                </el-form-item>
              </v-col>
              <v-col cols="12" sm="6">
                <el-form-item label="City" prop="city">
                  <el-input :id="'city' + form.id" v-model="form.city" @change="handleAutoSave(i, form)" style="width: 100%" />
                </el-form-item>
              </v-col>
              <v-col cols="12" sm="6">
                <el-form-item label="Level of Post-Secondary Education Attained" prop="level_of_post_degree">
                  <el-select :id="'level_of_post_degree' + form.id" v-model="form.level_of_post_degree" @change="handleAutoSave(i, form)" style="width: 100%">
                    <el-option v-for="(item, index) in array" :key="index" :label="item" :value="item">{{ item }}</el-option>
                  </el-select>
                </el-form-item>
              </v-col>
              <v-col cols="12" sm="6">
                <el-form-item label="Field of Study" prop="field_of_study">
                  <el-input :id="'field_of_study' + form.id" v-model="form.field_of_study" @change="handleAutoSave(i, form)" style="width: 100%" />
                </el-form-item>
              </v-col>
              <v-col cols="12" sm="6" v-show="sectionSlug !== 'outsideCanada'">
                <el-form-item label="If Other, Enter Field of Study" prop="other">
                  <el-input :id="'other' + form.id" v-model="form.other" @change="handleAutoSave(i, form)" style="width: 100%" />
                </el-form-item>
              </v-col>
              <v-col cols="12">
                <v-btn :loading="loading" :disabled="loading" color="primary" small @click.native="submitForm(i,form)">
                  {{ $t('global.save') }}
                </v-btn>
                <v-btn color="error" small @click.native="deleteItem(form,i)">Delete</v-btn>
              </v-col>
            </v-row>
          </el-form>
        </el-collapse-item>
      </el-collapse>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import autosave from '@/mixins/autosave.js'

export default {
  mixins: [autosave],
  props: {
    sectionId: {
      type: String
    },
    sectionSlug: {
      type: String
    },
    sectionLabel: {
      type: String
    },
    sectionInfoBox: {
      type: String
    },
    memberUID: {
      type: String,
      required: true
    },
    memberID: {
      type: String,
      required: true
    },
    datas: {
      type: Array
    }
  },
  data() {
    return {
      edit: false,
      formItem: {
        application_id: this.$route.params.id,
        member_uid: this.memberUID,
        member_id: parseFloat(this.memberID),
        slug: this.sectionSlug,
        from_date: null,
        to_date: null,
        name_of_school: null,
        country_id: null,
        province_id: null,
        city: null,
        level_of_post_degree: null,
        field_of_study: null,
        other: null,
        sec_org_id: parseInt(localStorage.getItem('org_id'))
      },
      activeNames: -1,
      selectProvine: false,
      url: 'imms_table/imm_1294_education_history',
      deleteUrl: 'imms/imm_1294_education_history',
      loading: false,
      items: [],
      array: [
        "Secondary School or less",
        "Associate Degree",
        "Post-Secondary Diploma/Certificate (non-trades)",
        "Post-Secondary Diploma/Certificate (trades)",
        "Bachelor's Degree",
        "Post-Graduate Certificate/Diploma",
        "Master's Degree",
        "Doctorate/PhD"
      ]
    }
  },
  watch: {
    memberUID: function() {
      this.fetchData()
    }
  },
  computed: {
    ...mapGetters({
      country: 'other/country',
      province: 'other/province'
    })
  },
  mounted() {
    this.fetchData()
    this.$store.dispatch('other/getProvince', 42)
  },
  methods: {
    getProvince(item) {
      if (item.country_id) {
        item.country_id = parseFloat(item.country_id)
      }
      if (item.province_id) {
        item.province_id = parseFloat(item.province_id)
      }
    },
    fetchData() {
      this.$Progress.start()
      var url = `table/imm_1294_edu_history_view?filter=((member_uid=${this.memberUID})AND(slug=${this.sectionSlug}))&order=from_date DESC, to_date DESC`;
      this.$store.dispatch('store/get', url)
        .then(response => {
          this.items = response.resource

          if (this.datas !== undefined) this.checkItemsFields(response.resource, this.datas, this.sectionId)
          this.$Progress.finish()
        })
        .catch(err => {
          this.$Progress.fail()
        })
    },
    nodeClear() {
      this.formItem = {
        application_id: this.$route.params.id,
        member_uid: this.memberUID,
        member_id: parseFloat(this.memberID),
        slug: this.sectionSlug,
        from_date: null,
        to_date: null,
        name_of_school: null,
        country_id: null,
        province_id: null,
        city: null,
        level_of_post_degree: null,
        field_of_study: null,
        other: null,
        sec_org_id: parseInt(localStorage.getItem('org_id'))
      }
      this.edit = false
    },
    saveForm() {
      this.nodeClear()
      this.edit = false
      this.items.push(this.formItem)
      var len = this.items.length
      this.activeNames = len
    },
    submitForm(index, formObj) {
      this.$refs.form[index].validate((valid) => {
        if (valid) {
          this.loading = true
          if (formObj.id != undefined) this.edit = true
          var action = 'store/save'
          if (this.edit) {
            action = 'store/edit'
          }
          this.$Progress.start()
          this.$store.dispatch(action, { 'url': this.url, 'data': formObj })
            .then(response => {
              if (response.data.resource && response.data.resource.length > 0) {
                formObj.id = response.data.resource[0].id
                formObj.imms_uuid = response.data.resource[0].imms_uuid
              }
              this.$store.dispatch('toaster/add', { text: 'Save', type: 'success' })
              this.$Progress.finish()
              this.activeNames = -1
              this.loading = false
            })
            .catch(err => {
              this.$store.dispatch('toaster/add', { text: 'Error', type: 'success' })
              this.$Progress.fail()
              this.loading = false
            })
        }
        else {
          return false
        }
      })
    }
  }
}
</script>
